import React from 'react';

const ErrorComponent = props => (
  <svg width={16} height={16} {...props}>
    <defs>
      <circle id="prefix__a" cx={8} cy={8} r={8} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <use fill="#FF475A" xlinkHref="#prefix__a" />
      <g mask="url(#prefix__b)" fill="#FF5C5C">
        <path d="M0 0h16v16H0z" />
      </g>
      <path
        d="M8.571 7.429h2.854A.58.58 0 0 1 12 8a.567.567 0 0 1-.575.571H8.57v2.854A.58.58 0 0 1 8 12a.567.567 0 0 1-.571-.575V8.57H4.575A.58.58 0 0 1 4 8c0-.316.248-.571.575-.571H7.43V4.575A.58.58 0 0 1 8 4c.316 0 .571.248.571.575V7.43z"
        fill="#FFF"
        mask="url(#prefix__b)"
        transform="rotate(45 8 8)"
      />
    </g>
  </svg>
);

export default ErrorComponent;



// WEBPACK FOOTER //
// ./src/components/Form/FormHelper/iconComponent/errorCmp.js